"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _index = require("./featuredSidebar/index.lazy");

var _featuredBanner = _interopRequireDefault(require("./featuredBanner"));

var _zod = require("zod");

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var showWidget = function showWidget(widget, data) {
  var widgetComponents = {
    featuredSide: (0, _preact.h)(_index.FeaturedSidebar, {
      data: data
    }),
    featuredBanner: (0, _preact.h)(_featuredBanner.default, {
      data: data
    })
  };
  return widgetComponents[widget];
};

var widgetName = 'announcement_card';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-announcement_card';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.unknown();

exports.config = config;

var FeaturedTopicsWrapper = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FeaturedTopicsWrapper, _Component);

  var _super = _createSuper(FeaturedTopicsWrapper);

  function FeaturedTopicsWrapper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FeaturedTopicsWrapper);
    _this = _super.call(this, props);
    _this.state = {
      data: []
    };
    return _this;
  }

  (0, _createClass2.default)(FeaturedTopicsWrapper, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var res;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _axios.default.get("/widget/".concat(this.props.widget));

              case 2:
                res = _context.sent;
                this.setState({
                  data: res.data
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var widget = this.props.widget;
      var data = this.state.data;

      if (!data.length) {
        return null;
      }

      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('widget--notification', 'qa-widget-notification', 'custom-notification')
      }, (0, _preact.h)("div", {
        className: widget
      }, showWidget(widget, data)));
    }
  }]);
  return FeaturedTopicsWrapper;
}(_preact.Component);

var _default = FeaturedTopicsWrapper;
exports.default = _default;